angular
  .module('company')

  .factory('DocumentCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class DocumentCrud extends Crud {
        constructor(list) {
          super(
            'document' + (list || ''),
            '@@apiUrl' + '/documents' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }
      return DocumentCrud;
    }
  ]);
